import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "./HeightPin";
import GemDiscover from "./elements/GemDiscover";
import CardFlip from "./elements/CardFlip";

function InteractiveSection(props) {
    const {store, color, state, questions, ipsums, index} = props;

    const ipsumArr = [];
    for (let i = 0; i < ipsums; i++) {
        ipsumArr.push(`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore
                    eu nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                    mollit nim id est laborum`);
    }

    return (
        <Fragment>
            <div className={'InteractiveSection'}>
                <div className={'full'}>
                    <h1>TITLE</h1>
                    <div className={'card'}>
                        <img className={'img-lt'} src="img/Berkeley.jpg" alt="Berkeley Campus"/>
                        <div className={'text-rt'}>Work will be undertaken within the Civil and Environmental
                            Engineering
                            Department
                            (CEE) of UC Berkeley, conducted by the university’s Airport Design Studio – a specialised
                            lab
                            dedicated to airport research within the CEE. The partnership will enable both parties to
                            examine
                            various aspects of the future of air travel, including sustainability, urban air mobility
                            and
                            electric aircraft.
                        </div>
                    </div>
                </div>

                <HeightPin store={store} state={state}
                           scrollChild={<div>
                               {ipsumArr.map((v, i) => <div key={`ipsum_${i}`} className={'side-card'}>
                                   {v}
                               </div>)}
                           </div>}
                           pinChild={<div className={'sticky-image'}>
                               <div className={'border'}>
                                   <div className={'content'}>
                                       This is a sticky image
                                   </div>
                               </div>
                           </div>}
                />

                <div className={'interactive'}>


                    <CardFlip color={color} index={index} store={store}
                        frontFace={<Fragment>
                            {questions && <div className={'card'}>
                                <h2>What do you think?</h2>
                                <div className={'form-input'}>
                                    <input type={'checkbox'}/><span>Option 1</span>
                                </div>

                                <div className={'form-input'}>
                                    <input type={'checkbox'}/><span>Option 2</span>
                                </div>
                                <div className={'form-input'}>
                                    <input type={'checkbox'}/><span>Option 3</span>
                                </div>
                            </div>}
                        </Fragment>}
                        backFace={<Fragment>
                            {/*<GemDiscover store={store} color={color} index={index}/>*/}
                            <div>RESULTS</div>
                        </Fragment>
                        }/>


                </div>
            </div>
        </Fragment>
    );
}

export default observer(InteractiveSection);
